import {h, Fragment} from "preact"
import { defaultConfig } from "../config"
import { HistoryElement, useAppStateSelector } from "@nosto/preact"
import { useEffect } from "preact/hooks"

export default function History() {
    const historyItems = useAppStateSelector(state => state.historyItems)

    useEffect(()=>{
        nostojs(function(api) {
            var request = api.createRecommendationRequest();
            request.addElements(['ns-autocomplete-rec']);
            request.loadRecommendations();
        });

        document.querySelector("#WebSearchForm > svg").style.backgroundColor = "white";
        document.querySelectorAll("#WebSearchForm > svg path").forEach((p) => {
            p.style.fill = "black";
            p.style.fillOpacity = 0.3;
        })
        document.querySelector('#WebSearchForm > .nosto-autocomplete-wrapper > .nosto-autocomplete-wrapper > div:nth-child(2)').classList.add('ns-d-block');
    }, [])

    return (
          <div
              class="ns-autocomplete ns-history-outer ns-absolute ns-d-flex ns-flex-column ns-flex-sm-row ns-align-items-start ns-background-white ns-border-box ns-mx-auto"
              data-nosto-element="autocomplete"
          >
              <div class="ns-w-100 ns-mt-sm-auto">
                {historyItems.length > 0 &&
                <div class="ns-history ns-autocomplete-keywords">
                  <div class="ns-autocomplete-header">Recently Searched</div>
                    <div class="ns-keywords ns-d-flex ns-flex-column">
                        {historyItems?.slice(0, defaultConfig.historySize).map(item => (
                            <HistoryElement key={item} query={{ query: item }}>
                                <div class="ns-keyword">
                                    {item}
                                </div>
                            </HistoryElement>
                        ))}
                    </div>
                </div>
                }
                  <div class="ns-d-flex ns-flex-column">
                        {window.nostoSearchTerms &&
                          <div class="ns-autocomplete-keywords ns-d-flex ns-flex-column">
                              <div class="ns-autocomplete-header">Trending Searches</div>
                              <div class="ns-d-flex ns-flex-row ns-flex-wrap ns-keywords ns-trending-wrapper">
                                {window.nostoSearchTerms?.map((term) => {
                                    var termSlug = term.replaceAll(" ", "+")
                                    return (
                                        <a class="ns-trending" href={`https://bohme.com/search?q=${termSlug}`}>{term}</a>
                                        // <div class="ns-trending">
                                        //     <a href={`https://bohme.com/search?q=${termSlug}`}>{term}</a>
                                        // </div>
                                    )
                                })}
                              </div>
                          </div>
                        }
                      
                          <div class="ns-autocomplete-products ns-d-flex ns-flex-column ns-flex-grow-1">
                            <div class="nosto_element" id="ns-autocomplete-rec"></div>
                          </div>
                  </div>
              </div>
          </div>
    )
}
